import { render, staticRenderFns } from "./CouponCourse.vue?vue&type=template&id=97ebd95e&"
import script from "./CouponCourse.vue?vue&type=script&lang=js&"
export * from "./CouponCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports